import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let AlertsInfoNotificationIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M14.206 21.031c.191.056.352.185.447.36.096.175.118.38.062.571-.357 1.208-1.465 2.038-2.725 2.039-1.258-.001-2.365-.832-2.718-2.039-.11-.395.117-.806.51-.922.395-.116.808.107.929.499.165.571.688.965 1.282.965.595 0 1.118-.393 1.283-.964.119-.395.533-.622.93-.509zM11.991.001c.414 0 .75.336.75.75v1.534c4.251.382 7.506 3.948 7.5 8.216 0 6.303 1.246 7.686 1.258 7.699.222.21.296.533.187.818-.109.29-.385.482-.695.483h-18c-.286 0-.548-.164-.674-.421-.127-.258-.094-.565.083-.791.006-.009 1.341-1.939 1.341-7.788-.006-4.268 3.249-7.834 7.5-8.216V.751c0-.414.336-.75.75-.75zm-.001 3.75c-3.722 0-6.75 3.028-6.75 6.75 0 3.957-.58 6.277-1.046 7.5h15.507c-.482-1.232-.961-3.47-.961-7.5 0-3.722-3.028-6.75-6.75-6.75z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
AlertsInfoNotificationIcon = __decorateClass([
  customElement("elm-alerts-info-notification-icon")
], AlertsInfoNotificationIcon);
export { AlertsInfoNotificationIcon };
